<template>
  <!-- CONTENT -->
  <div class="page-layout__inner detailed-results">
    <div class="page-layout__group">
      <!-- PERSON'S MAIN INFO -->
      <section class="section employee-card  employee-card-expanded" style="z-index:2">
        <div class="employee-card__inner">
          <!-- LEFT -->
          <div v-if="candidate.id" class="employee-card__left">
            <div class="employee-card__header">
              <a class="employee-card__toggle-btn" href="javascript:void(0)" @click="()=>{ $router.push({'name':'api.candidate.get',params:{id:candidate.id}}) }">
                <h2 class="employee-card__title">{{ candidate.fullName }}</h2>
              </a>
            </div>

            <div class="employee-card__body">
              <div class="person">
                <div class="person__inner">
                  <div class="person__img--3x4 mr-3" id="upload-photo">
                    <img :src="candidate.photoUrl || $config.noProfilePhotoUrl"/>

                    <div class="change_avatar" v-if="hasPermission('api.candidate.profile.photoChange')">
                      <p>
                        <a id="change_photo" @click="$refs.avatarSelect.click()">
                          {{ getTranslation('uploadNewAvatar') }}
                        </a>
                      </p>

                      <input @change="uploadAvatar" style="display: none" ref="avatarSelect" type="file" accept="image/*"/>
                    </div>
                  </div>

                  <div class="person__info">
                    <p class="text  text--lg">{{ candidate.pin }}</p>
                    <p class="text  text--md">{{ candidate.bdate }} ({{ candidate.age }})</p>
                    <p class="text  text--md">{{ candidate.email }}</p>
                    <p v-if="candidate.isWinner">
                      <span class=" text  text--lg badge badge--success"> {{ getTranslation('appWinner') }}
                        <svg class="candidate-icon icon ml-2" style="fill: #ffffff">
                        <use xlink:href="#icon__favorites"></use>
                      </svg>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.employee-card__body -->
          </div>
          <!-- / LEFT -->


          <!-- RIGHT -->
          <div class="employee-card__right">
            <div class="employee-card__header">
              <div class="employee-card__status">
                <span v-if="candidate.testingCandidateEvent && candidate.testingCandidateEvent.isToFindWinner" class="badge badge--warning">
                            {{ getTranslation('findHighestPoint') }}
                        </span>
              </div>
            </div>

            <div class="employee-card__body row">
              <div class="employee-card__table col-md-6">
                <table v-if="app.id" class="table-doc">
                  <tbody>
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('appName') }}:
                    </th>
                    <td class="table-doc__cell">
                      <router-link :to="{name:'api.application.get',params:{id:app.id},query:{tab:'results'}}">
                        {{ app.title }}
                      </router-link>
                    </td>
                  </tr>
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('position') }}:
                    </th>
                    <td v-if="app.resource.positionName" class="table-doc__cell">
                      {{ app.resource.positionName }}
                    </td>
                    <td v-else-if="app.resource.resourceTitle" class="table-doc__cell">
                      {{ app.resource.resourceTitle }}
                    </td>
                  </tr>
                  <tr v-if="app.resource.postScopeText">
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('postScope') }}:
                    </th>
                    <td class="table-doc__cell">
                      {{ getTranslation(app.resource.postScopeText) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('totalPoint') }}:
                    </th>
                    <td class="table-doc__cell">
                      <span class="badge text--md"> {{ candidate.totalPoint }} / {{ candidate.totalScore }} </span>
                    </td>
                  </tr>
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('status') }}:
                    </th>
                    <td class="table-doc__cell">

                      <div class="mytooltip-wrapper" style="display: inline-block">
                                                   <span class="badge text--md" :class="{'badge--success': candidate.resultStatus ==='PASSED','badge--accent': candidate.resultStatus ==='FAILED','badge--warning':candidate.resultStatus==='TESTING_CANCELLED','badge-info':candidate.resultStatus ==='IN_TESTING'}">
                                                       {{ getTranslation(candidate.resultStatus === 'TESTING_CANCELLED' ? 'TESTING_CANCELLED' : 'CANDIDATE_' + candidate.resultStatus) }}
                                                   </span>
                        <div v-if="candidate.resultStatus==='TESTING_CANCELLED'" class="mytooltip  mytooltip--dark  mytooltip--bottom-right" style="right:0">
                          <div class="mytooltip__arrow"></div>
                          <div class="mytooltip__header  pb-0">
                            <div class="mytooltip__header-inner">
                              <h4 class="mytooltip__title  mytooltip__title--light">{{ getTranslation('eventRejectComment') }}</h4>
                              <div class="mytooltip__controls" v-if="hasPermission('api.testing.event.get')">
                                <router-link :to="{ name: 'api.testing.event.get', params: { id:candidate.testingCandidateEvent.eventId} }"
                                             class="btn btn--sm btn--link">{{ getTranslation('moreInfo') }}
                                </router-link>
                              </div>
                            </div>
                          </div>
                          <div class="mytooltip__body">
                            <p> {{ candidate.testingCandidateEvent.event.comment }}</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ capitalizeFLetter(getTranslation('percentage')) }}:
                    </th>
                    <td class="table-doc__cell">
                          <span class="text--bold" :class="{'text--success': candidate.resultStatus === 'PASSED','text--danger':candidate.resultStatus === 'FAILED'}">
                              {{ getPercentage(candidate.totalScore, candidate.totalPoint) }}%
                          </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="candidate.testingCandidateEvent" class="employee-card__contacts col-md-6">
                <table class="table-doc">
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('identification') }}:
                    </th>
                    <td class="table-doc__cell">
                      {{ getTranslation(candidate.loginLabel) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('language') }}:
                    </th>
                    <td class="table-doc__cell">
                      {{ $lang.app[candidate.testingCandidateEvent.lang] }}
                    </td>
                  </tr>

                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('startTime') }}:
                    </th>
                    <td class="table-doc__cell">
                      {{ momentFormatDate(candidate.testingCandidateEvent.startTime, 'HH:mm^ss') }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('finishTime') }}:
                    </th>
                    <td class="table-doc__cell">
                      {{ momentFormatDate(candidate.testingCandidateEvent.endTime, 'HH:mm^ss') }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">
                      {{ getTranslation('testingDate') }}:
                    </th>
                    <td class="table-doc__cell">
                      {{ momentFormatDate(candidate.testingCandidateEvent.startTime, 'DD.MM.YYYY') }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('testStructureDuration') }}:</th>
                    <td class="table-doc__cell">
                      {{ candidate.testingCandidateEvent.durationSpent }}
                    </td>
                  </tr>

                </table>
              </div>
            </div>
            <!-- /.row -->
          </div>
          <!-- / RIGHT -->
        </div>
        <!-- /.employee-card__inner -->

      </section>
      <!-- / PERSON'S MAIN INFO -->
      <section v-if="candidate.id" class="tab-3 mt-3">
        <ul class="nav  tabs-3__nav  tabs-3__hor-nav">
          <li v-if="hasPermission('api.candidate.profile.logins')" class="tabs-3__nav-item">
            <a @click="tabSelect('logins')" :class="'tabs-3__nav-link' + (tabs['logins'] ? ' active' : '')" href="javascript:void(0)">
              {{ getTranslation('loginHistory') }}
            </a>
          </li>
          <li v-if="hasPermission('api.candidate.profile.testResults')" v-for="test in tests" v-bind:key="test.test_type_id" class="tabs-3__nav-item">
            <a @click="tabSelect('test'+test.test_type_id)" :class="'tabs-3__nav-link' + (tabs['test'+test.test_type_id] ? ' active' : '')" href="javascript:void(0)">
              {{ test.test_type }}
              <span class="badge">{{ test.total_point }}</span>
            </a>
          </li>
        </ul>
        <div class="tabs-3__content  tabs-3__content--p-0">
          <div v-if="hasPermission('api.candidate.profile.logins')" class="tabs-3__pane" :class="{ 'active': tabs['logins'] }">
            <CandidateLogins :active="tabs['logins']" :candidate-id="$route.params.id" :app-id="$route.params.appId" :paginated="false"/>
          </div>
          <div v-if="hasPermission('api.candidate.profile.testResults')" v-for="test in tests" v-bind:key="test.test_type_id" class="tabs-3__pane" :class="{ 'active': tabs['test'+test.test_type_id] }">
            <DetailedResultComponent :active="tabs['test'+test.test_type_id]" :test="test" :result="candidate.testingCandidateEvent"/>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import candidateProfileMixin from './mixins/CandidateProfile';
import CandidateMixin from './mixins/Candidate';
import DetailedResultComponent from './components/DetailedResultComponent';
import CandidateLogins from './components/CandidateLogins';

export default {
  name: 'DetailedResults',
  components: {CandidateLogins, DetailedResultComponent},
  mixins: [candidateProfileMixin, CandidateMixin],
  data() {
    return {
      app: {},
      resultId: this.$route.query.resultId || null,
      tabs: {
        test1: false,
        test2: false,
        test4: false,
        test5: false,
        test6: false,
        test7: false,
        test8: false,
        test9: false,
        test10: false,
        test11: false,
        logins: false,
      },
      tests: [],
    };
  },
  created() {
    this.fetchResults();
    this.fetchApplication(this.$route.params.appId);
  },
  updated() {
    this.setHeadings({
      title: this.getTranslation('candiateDetailedResults'),
      breadcrumbs: [
        {
          label: this.getTranslation('candidates'),
          route: {name: 'api.candidate.getList'},
        },
        {
          label: this.getTranslation('candidateInfo'),
          route: {name: 'api.candidate.get', params: {id: this.$route.params.id}},
        },
        {
          label: this.getTranslation('candiateDetailedResults'),
        },
      ],
      toBack: {
        route: {name: 'api.candidate.get', params: {id: this.$route.params.id}, query: {tab: 'applications'}},
        label: this.getTranslation('gotoBack'),
      },
    });
  },
  methods: {
    fetchApplication(appId) {
      return this.axios.get(this.$config.urls.application.fetchApplication.url.replace(':id', appId)).then(response => {
        this.app = response.data.data;
      }).catch(() => {
      });
    },
    fetchResults() {
      return this.axios.get(this.$config.urls.candidate.fetchDetailedResults.url.replace(':id', this.$route.params.id), {
        params: {appId: this.$route.params.appId, resultId: this.resultId},
      }).then(response => {
        this.candidate = response.data.data.candidate;
        this.tests = response.data.data.tests;
      }).catch(() => {
      });
    },
  },
};
</script>

<style scoped>
.text--md {
  font-size: 15px !important;
}

.employee-card__left {
  width: 35% !important;
}

.employee-card__right {
  width: 65% !important;
}

@media (min-width: 992px) {
  .employee-card:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    width: 35% !important;
    height: 100%;
    background-color: #F7FAFF !important;
  }
}

.employee-card-expanded {
  max-width: 100% !important;
}

.exam__question-text {
  color: #0d3272 !important;
}
</style>
